// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bronosTestnet as _bronosTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bronosTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1038
 * Chain Name: Bronos Testnet
 * Default Block Explorer: https://tbroscan.bronos.org
 * Default RPC URL: https://evm-testnet.bronos.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bronosTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bronosTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bronosTestnet = createCommon({
	..._bronosTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
